import { render, staticRenderFns } from "./business_item.vue?vue&type=template&id=0bdb5f22&scoped=true&"
import script from "./business_item.vue?vue&type=script&lang=ts&"
export * from "./business_item.vue?vue&type=script&lang=ts&"
import style0 from "./business_item.vue?vue&type=style&index=0&id=0bdb5f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdb5f22",
  null
  
)

export default component.exports